import React from "react";

const AccountGraphInverted = props => (
  <svg width="20" height="21" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#34679D" d="M0 .36h20v20H0z" />
      <path
        d="M3 10.36h2"
        stroke="#FFF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4 10.36h1"
        stroke="#FFF"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M5 5.36h5.195M11 3.36h5.172M11.03 8.36h5.142M11.03 12.36h5.142M11.03 17.36h5.142M5 15.36h5.195M5 9.36v-4M11 6.36l.034-3M11 8.36l.034-3M11 17.36l.034-3M11 15.36l.034-3M5 11.36v4"
        stroke="#FFF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default AccountGraphInverted;
